import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

import { StaticPagesService } from 'src/app/Services/static-pages.service';
import Swal from 'sweetalert2';

import { TranslateService } from '@ngx-translate/core';

import { MenuItems } from '../../../Core/menu/menu-items/menu-items';
import { EmbryoService } from '../../../Services/Embryo.service';
import { HomePageService } from '../../../Services/home-page.service';
import * as dynamicForms from '../../../static-data/dynamic-forms-list-mock';
import { DynamicFormService } from 'src/app/Services/dynamic-form.service';

@Component({
  selector: 'FooterOne',
  templateUrl: './FooterOne.component.html',
  styleUrls: ['./FooterOne.component.scss'],
})
export class FooterOneComponent implements OnInit {
  @ViewChild('subscribeFormReset', { static: true })
  private subscribeFormReset!: NgForm;
  environmentVariables: any;
  subscribeForm!: FormGroup;
  lang: any;
  loadingStatic = false;
  fakeArray = new Array(4);
  enableAffiliate: boolean = false;
  staticPages = [];
  currentYear: number = new Date().getFullYear();
  copyrightEn: string = '';
  copyrightAr: string = '';
  dynamicForms: any[] = [];
  loadingDynamicForms: boolean = false;
  emailValidator : any =
  "^[a-zA-Z]{1}[a-zA-Z0-9.-_]*@[a-zA-Z]{1}[a-zA-Z.-]*[a-zA-Z]{1}[.][a-zA-Z]{2,}$";

  constructor(
    public menuItems: MenuItems,
    private formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    public router: Router,
    public homePageService: HomePageService,
    public embryoService: EmbryoService,
    public translate: TranslateService,
    private pagesService: StaticPagesService,
    private dynamicFormService: DynamicFormService,
  ) {
    this.getInitilizingData();
    embryoService.emitLang.subscribe((lang: string) => {
      translate.setDefaultLang(lang);
      this.lang = lang;
      this.copyRightValue();
    });
    this.getStaticPages();
    this.getDynamicForms();
  }
  getInitilizingData() {
    this.pagesService.getenvConfig().subscribe((res) => {
      this.environmentVariables = res;
    });
  }

  ngOnInit() {
    this.lang = localStorage.getItem('lang');
    this.translate.setDefaultLang(this.lang);
    this.subscribeForm = this.formBuilder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(this.emailValidator),
        ],
      ],
    });
  }

  getStaticPages() {
    this.loadingStatic = true;
    this.pagesService.getAllStaticPages().subscribe((res: any) => {
      if (res.code === 200) {
        this.staticPages = res.data;
        this.loadingStatic = false;
      }
    });
  }

  getDynamicForms() {
    this.loadingDynamicForms = true;
    this.dynamicFormService.getAllDynamicForms().subscribe((res) => {
      if (res.code === 200) {
        this.dynamicForms = res.data;
        this.loadingDynamicForms = false;
      }
    })
    // let res = dynamicForms.dynamicForms;
    // if (res.code === 200) {
    //   this.dynamicForms = res.data;
    //   // this.loadingDynamicForms = false;
    // }
  }

  public subscribe(): void {
    if (this.subscribeForm.invalid) {
      this.subscribeForm.markAllAsTouched();
      return;
    }
    const email = this.subscribeForm.value;
    this.homePageService.subscribeEmail(email).subscribe((response: any) => {
      if (response.code === 200) {
        this.snackBar.open(response.message, '×', {
          panelClass: 'success',
          verticalPosition: 'top',
          duration: 3000,
        });
        this.subscribeFormReset.resetForm();
      } else {
        this.snackBar.open(response.message, '×', {
          panelClass: 'error',
          verticalPosition: 'top',
          duration: 3000,
        });
      }
    });
  }

  routing(typeRouting: any) {
    if (localStorage.getItem('auth_user_crocs')) {
      if (typeRouting == 'account') {
        this.router.navigate(['/' + this.lang + '/account/profile']);
      } else if (typeRouting == 'orders') {
        this.router.navigate(['/' + this.lang + '/account/order-history']);
      } else if (typeRouting == 'affiliate') {
        this.router.navigate(['/' + this.lang + '/session/signup-affiliate']);
      }
    } else {
      this.router.navigate(['/' + this.lang + '/session/signin']).then(() => {
        Swal.fire({
          html: `<p style='color:white'>${
            this.lang == 'en'
              ? 'Please, login first!'
              : ' الرجاء تسجيل الدخول أولا!'
          }</p>`,
          width: 250,
          position: 'bottom-end',
          background: '#bd362f',
          timerProgressBar: true,
          showConfirmButton: false,
          timer: 3000,
          backdrop: false,
          allowOutsideClick: true,
        });
      });
    }
  }

  copyRightValue(): void {
    this.copyrightEn = `COPYRIGHT © (${this.currentYear}) ${this.environmentVariables?.APP_NAME}. ALL RIGHTS RESERVED. POWERED BY`;
    this.copyrightAr = `حقوق الطبع والنشر © (${this.currentYear}) ${this.environmentVariables?.APP_NAME_AR} . جميع الحقوق محفوظة.`;
  }

	redirectToLink(page:any){
		page.flag == 'GENERAL'?
			this.router.navigate([`/${this.lang}/pages/${page.slug}`]):
			this.router.navigate([`/${this.lang}/${page.slug}`]);
  }

	redirectToFormLink(page:any){
		this.router.navigate([`/${this.lang}/forms/${page.slug}`]);
  }


 getImageName(imageSrc :any) {
      if(imageSrc){
      var imageSrcParts = imageSrc?.split('/');
      var imageName = imageSrcParts[imageSrcParts?.length - 1];
      return imageName;
    }
  }

}
